import styled from 'styled-components';
import { techColors, terminalBorder, neonGlow, terminalTextStyle } from './TechRetroEffects';
import { getNotificationTheme } from '../utils/notificationTypes';

export const ToastNotification = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'show' && prop !== 'type',
})`
  position: fixed;
  top: 14px;
  right: 96px;
  background: ${techColors.darkBgSecondary};
  ${({ type }) => {
    const { color, glow } = getNotificationTheme(type);
    return `${terminalBorder(color)}\n${neonGlow(color, glow)}`;
  }}
  color: ${({ type }) => getNotificationTheme(type).color};
  padding: 10px 16px;
  border-radius: 4px;
  z-index: 10000;
  font-size: 12px;
  font-weight: 500;
  max-width: 400px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) => (show ? 'translateY(0)' : 'translateY(-20px)')};
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: ${({ show }) => (show ? 'auto' : 'none')};
  display: flex;
  align-items: flex-start;
  gap: 10px;
  ${terminalTextStyle}

  @media (max-width: 768px) {
    top: max(62px, calc(env(safe-area-inset-top) + 54px));
    right: 10px;
    left: 10px;
    max-width: none;
    padding: 12px 16px;
    font-size: 12px;
  }
`;

export const ToastMessage = styled.span`
  flex: 1;
  line-height: 1.4;
  word-break: break-word;
`;

export const ToastCloseButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'type',
})`
  background: transparent;
  border: none;
  color: ${({ type }) => getNotificationTheme(type).color};
  cursor: pointer;
  padding: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  transition: background 0.2s ease;
  flex-shrink: 0;
  opacity: 0.85;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    opacity: 1;
  }

  &:active {
    background: rgba(255, 255, 255, 0.15);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const ToastIconWrap = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== 'type',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  color: ${({ type }) => getNotificationTheme(type).color};

  svg {
    width: 18px;
    height: 18px;
  }
`;
